export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [4,[2]],
		"/(app)/details": [5,[2]],
		"/(app)/edit": [6,[2]],
		"/(app)/offline": [7,[2]],
		"/(app)/search": [8,[2]],
		"/(app)/signedout": [9,[2]],
		"/(app)/signin": [10,[2]],
		"/zorgabdoc": [11,[3]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	

	reroute: (() => {})
};

export { default as root } from '../root.svelte';